const listPointsBody = document.querySelector('#places').querySelector('div[name=body]');
// import auth from '../tools/storage.js';

export default {

  cleanContainer() {
    listPointsBody.innerHTML = '';
  },

  getElement(item, countHalls) {
    console.log(item);
    // let nonephoto = '<img src="../img/photo-none.png">';
    let htmlDesc = ` hID=${item.id}  pName=\'${item.name}\'  `;
    let cssIsChairman = '';
    let actionBTS = '';
    if (countHalls != 1) {
      actionBTS = `
                  <button  class="btn  p-0 icon-btn btn__edit_simple" action=renameHall${htmlDesc}></button>
                  <button  class="btn  p-0 icon-btn btn__delete_simple"  action=deleteHall ${htmlDesc}></button>
                  `;
    }
    if(item.isChairman)
      cssIsChairman = 'isChairman';
    // if (item.image && item.image.length > 2) 
      // nonephoto = '<img src="../img/photo-has.png">';
    return `<div class="cardHall  ${cssIsChairman} row"  action=renameHall ${htmlDesc}>
                      <div class="ml-3 mr-auto" action=renameHall ${htmlDesc} >${(item.name) ? (item.name) : 'Основной зал'}</div>
                      <div class="mr-3 ml-auto" action=renameHall ${htmlDesc} >
                                ${actionBTS}
                      </div>
                    </div>`;

  },

  drawDataInContainer(servAnswer) {
    let oldSection;
    let fullHtml = '';
    if (servAnswer) {
      oldSection = -99;
      servAnswer.forEach((item, index) => {
        if (oldSection != item.id) {
          let countHalls = 0;
          if (item.halls)
            countHalls = item.halls.length;

          let coord = '';
          if (parseInt(item.onMap, 10) === 1) {
            coord = (item.lat) ? (item.lat) : '';
            coord += ' - ';
            coord += (item.lng)  ? (item.lng) : '';
          };

          oldSection = item.id;
          // console.log(item);
          if(fullHtml.length > 4)
            fullHtml += `</div></div>`;
          
          fullHtml += ` <div class = "block_items mb-1 block_items_hover ${(item.hidden) ? "hiddenElement":""}">
            <div class="row jury_section_name m-1 p-0"> 
              <div class="column w-90">

                <b>${item.name} </b> 
                <div class ="row w-100 m-0 p-1">
                  <div class="ml-auto">${(item.adress) ? (item.adress) : ''} </div> 
                  <div class="ml-auto"> ${coord} 
                  </div>
                </div>
              </div>
              <div class="w-10 row">
                <div class="linkCounter"><b>${item.countLinks}</b></div>
                <button  class="btn btn-success p-0 icon-btn icon-btn__edit" action=edit pID=${item.id} 
                pAdress = \'${item.adress}\'
                pLat = ${item.lat}  pLng = ${item.lng} onMap = ${item.onMap}
                pName = \"${item.name}\"></button>
                <button  class="btn btn-success p-0 icon-btn icon-btn__delete--red" countHalls=${countHalls} action=delete pID=${item.id} pName = \"${item.catName}\""></button>
              </div>
            </div>
            <div class = "row p-0 jury_section_body">
           `;
        }
        if (item.halls){

          item.halls.forEach((hall, index) => {
           fullHtml += this.getElement(hall, item.halls.length);
          });

        }
          

        fullHtml += `<div class="cardHall card_add row" action=newHall pID=${item.id}>
                      <h1 action=newHall  pID=${item.id} >+</h1>
                      <b action=newHall  pID=${item.id} >Добавить зал</b>
                    </div>`;
        // fullHtml += `</div>`;
        // listArbitorsBody.insertAdjacentHTML('beforeend', this.getElement(item, index))
      });

      fullHtml += `</div></div>`;
      listPointsBody.innerHTML = fullHtml;

    } else 
      listPointsBody.innerHTML = 'Секций жюри не обнаружено!'
  },

  drawMarkupInContainer(markup) {
    listPointsBody.insertAdjacentHTML('beforeend', markup);
  },

};
